import { MsalAuthService } from './msalAuthService';

angular.module('deliveryCreate.app')
    .service('MsalAuthService', ['$location', MsalAuthService]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/msal/bootstrap.ts
 **/